'use client'

import { useId, useMemo } from 'react'
import { cn } from '@/lib/utils'
import sidebarLogoSvg from '@/components/branding/SeoPulseSidebarLogoMarkSvg'

const ID_PATTERN = 'pattern0_455_961'
const ID_IMAGE = 'image0_455_961'

type SeoPulseSidebarLogoMarkProps = {
  className?: string
}

/** Figma Aside SIDEBAR (455:961): SVG mark inlined from Dev Mode export (pattern + raster). */
export function SeoPulseSidebarLogoMark({ className }: SeoPulseSidebarLogoMarkProps) {
  const uid = useId().replace(/:/g, '')
  const patternId = `sp-lg-p-${uid}`
  const imageId = `sp-lg-i-${uid}`

  const markup = useMemo(() => {
    return sidebarLogoSvg.replaceAll(ID_PATTERN, patternId).replaceAll(ID_IMAGE, imageId)
  }, [patternId, imageId])

  return (
    <span
      className={cn('block', className)}
      role="img"
      aria-label="SEO Pulse"
      dangerouslySetInnerHTML={{ __html: markup }}
    />
  )
}
